import { NotificationCenter } from '../NotificationCenter.models';
import { AnomalyDetectionNotification } from './AnomalyDetectionNotification';
import { AoisNotification } from './AoisNotification';
import { NdviThresholdNotification } from './NdviThresholdNotification/NdviThresholdNotification';
import { SystemNotification } from './SystemNotification/SystemNotification';
import { WeeklyFieldsInsightsNotification } from './WeeklyFieldsInsightsNotification/WeeklyFieldsInsightsNotification';

const NotificationListItemComponents: Record<
  NotificationCenter.NotificationService,
  React.FC<{ notification: NotificationCenter.Notification }>
> = {
  anomaly_notification: AnomalyDetectionNotification,
  image_download: AoisNotification,
  drone_upload: AoisNotification,
  weekly_field_insights: WeeklyFieldsInsightsNotification,
  system_notification: SystemNotification,
  ndvi_threshold_checker: NdviThresholdNotification,
};

export { NotificationListItemComponents };
